/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

class Estimate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      estimate: props.estimate ? props.estimate.toFixed(1) : 0.0
    };
    this.focusComponent = this.focusComponent.bind(this);
    this.handleEstimateChange = this.handleEstimateChange.bind(this);
    this.updateEstimate = this.updateEstimate.bind(this);
  }

  focusComponent(input) {
    if (this.props.autoFocus) {
      return input && input.focus();
    }
    return null;
  }

  handleEstimateChange(event) {
    event.preventDefault();
    let { value } = event.target;
    if (value.startsWith('.')) {
      value = '0'.concat(value);
    }
    if (this.isNumeric(value) || value === '') {
      this.setState({ estimate: value });
    }
  }

  isNumeric(n) {
    const parsedInput = parseFloat(n);
    return !Number.isNaN(parsedInput) && Number.isFinite(parsedInput);
  }

  updateEstimate(e) {
    if (e && e.target) e.target.placeholder = '0.0';
    const newEstimate = this.state.estimate
      ? parseFloat(this.state.estimate)
      : 0.0;
    this.props.onFieldChange({ estimate: Math.round(newEstimate * 10) / 10 });
  }

  /* eslint-disable jsx-a11y/label-has-associated-control */
  render() {
    const { estimate } = this.state;
    return (
      <div>
        {this.props.label ? (
          <label htmlFor="estimate">IDEAL HOURS:</label>
        ) : null}
        <input
          id="estimate"
          type="text"
          value={estimate}
          placeholder="0.0"
          onFocus={(e) => {
            if (e && e.target) e.target.placeholder = '';
          }}
          min={0}
          width="2"
          onChange={this.handleEstimateChange}
          onBlur={(e) => this.updateEstimate(e)}
          onKeyUp={(e) => {
            if (e.which === 13) {
              this.updateEstimate();
              e.target.blur();
            }
          }}
          ref={(input) => this.focusComponent(input)}
          disabled={!this.props.allowEdit}
        />
      </div>
    );
  }
}

Estimate.propTypes = {
  estimate: PropTypes.number,
  label: PropTypes.bool,
  autoFocus: PropTypes.bool,
  allowEdit: PropTypes.bool,
  onFieldChange: PropTypes.func
};

export default Estimate;
